import { apiSlice } from "../../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTablesdata: builder.mutation({
      query: ({ connectionId, selectedTable }) => ({
        url: "/connectpg/showColumns",
        method: "POST",
        body: {
          connectionId,
          selectedTable,
        },
      }),
      // Invalidate the 'DataSource' tag so that queries with this tag are refetched
      invalidatesTags: ["DataSource"],
    }),
    getDatasource: builder.query({
      query: () => ({
        url: "/connectpg/getdataSources",
        method: "GET",
      }),
      // Provide a tag that will allow it to be invalidated
      providesTags: ["DataSource"],
    }),
    getuploadCsv: builder.mutation({
      query: ({ formData }) => {
        // console.log(formData);
        return {
          url: "/python/csvupload",
          method: "POST",
          body: formData,
        };
      },
      // Add invalidatesTags to specify which tags should be invalidated after this mutation
      invalidatesTags: ["DataSource"],
    }),
    getExcelSheets: builder.mutation({
      query: (formData) => {
        // console.log();
        return {
          url: "/excel/excelupload",
          method: "POST",
          body: formData,
        };
      },
    }),
    uploadExcelSheets: builder.mutation({
      query: (payload) => ({
        url: "/excel/excelsheetUpload", // <-- replace with actual endpoint
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetTablesdataMutation,
  useGetDatasourceQuery,
  useGetuploadCsvMutation,
  useGetExcelSheetsMutation,
  useUploadExcelSheetsMutation,
} = sqlApiSlice;
